import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1, margin: "0px 0px 120px 0px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <p className="font-mono text-xs uppercase tracking-[0.25em] font-medium text-gold">
    {children}
  </p>
);

export const GhostWord = ({ word, align = "right", className = "" }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const x = useTransform(
    scrollYProgress,
    [0, 1],
    align === "right" ? ["8%", "-16%"] : ["-8%", "10%"],
  );
  return (
    <div ref={ref} aria-hidden="true" className={`pointer-events-none absolute inset-x-0 z-0 overflow-hidden ${className}`}>
      <motion.span
        style={{ x, WebkitTextStroke: "1.5px rgba(61,158,255,0.18)", color: "transparent" }}
        className="block whitespace-nowrap font-display text-[22vw] font-semibold leading-none tracking-tight lg:text-[13rem]"
      >
        {word}
      </motion.span>
    </div>
  );
};
